import React from 'react';
import styled, { css } from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  withBackgroundCSS,
  WithBackgroundProps,
} from 'app/shared/components/styleUtils/withBackgroundCSS';
import {
  withBorderCSS,
  WithBorderProps,
} from 'app/shared/components/styleUtils/withBorderCSS';
import {
  withCursorCSS,
  WithCursorProps,
} from 'app/shared/components/styleUtils/withCursorCSS';
import {
  withDimensionsCSS,
  WithDimensionsProps,
} from 'app/shared/components/styleUtils/withDimensionsCSS';
import {
  withDisplayCSS,
  WithDisplayProps,
} from 'app/shared/components/styleUtils/withDisplayCSS';
import {
  withFlexCSS,
  WithFlexProps,
} from 'app/shared/components/styleUtils/withFlexCSS';
import {
  withPositionCSS,
  WithPositionProps,
} from 'app/shared/components/styleUtils/withPositionCSS';
import {
  withShadowCSS,
  WithShadowProps,
} from 'app/shared/components/styleUtils/withShadowCSS';
import {
  withSpacingCSS,
  WithSpacingProps,
} from 'app/shared/components/styleUtils/withSpacingCSS';
import {
  withZIndexCSS,
  WithZIndexProps,
} from 'app/shared/components/styleUtils/withZIndexCSS';

export interface BoxProps
  extends React.ComponentPropsWithRef<'div'>,
    WithSpacingProps,
    WithFlexProps,
    WithBorderProps,
    WithShadowProps,
    WithPositionProps,
    WithDisplayProps,
    WithCursorProps,
    WithZIndexProps,
    WithBackgroundProps,
    WithDimensionsProps {
  visibility?: string;
  transition?: string;
  transform?: string;
  animation?: any;
  listStyle?: string;
  as?: React.ElementType;
}

interface BoxCSSProps extends BoxProps {
  theme: CommonTheme;
}

// Please keep withDisplayCSS BEFORE withFlexCSS
export const Box = styled.div<BoxCSSProps>`
  ${({
    visibility,
    transition = 'background-color 400ms',
    transform,
    animation,
    listStyle = 'none',
  }) => css`
    transition: ${transition};
    ${visibility && `visibility: ${visibility};`}
    ${transform && `transform: ${transform};`}
    ${
      animation &&
      css`
        animation: ${animation};
      `
    }
    list-style: ${listStyle};
  `}

  ${withBackgroundCSS};
  ${withDisplayCSS};
  ${withFlexCSS};
  ${withSpacingCSS};
  ${withBorderCSS};
  ${withShadowCSS};
  ${withDimensionsCSS};
  ${withPositionCSS};
  ${withCursorCSS}
  ${withZIndexCSS};
`;
